import AjaxService from '@services/AjaxService';

interface LegacyOption {
  key: string,
  value: string
}

interface OptionsResponse {
  options: LegacyOption[]
}

interface SelectOptionNumber {
  text: string,
  value: number
}

export default class FileCategoryGroupRepository {
  private readonly ajaxService: AjaxService;

  public constructor(ajaxService: AjaxService) {
    this.ajaxService = ajaxService;
  }

  public findForDropdown(recordId: string): Promise<SelectOptionNumber[]> {
    const url = '/de/Portal/ajax/dropdown/contentType/fileCategoryGroups/format/json'
      + '?module=damage&vehicleDamageRecordId=' + recordId;

    return this.ajaxService.getDropdownOptionsLegacy(url)
      .then((response: OptionsResponse) => {
        const options: SelectOptionNumber[] = [];
        for (const optionData of response.options) {
          options.push({
            value: parseInt(optionData.key, 10),
            text: optionData.value,
          })
        }
        return options;
      });
  }
}
